
import { defineComponent, ref, provide, onMounted, inject, nextTick, computed } from 'vue'
import { useStore } from "vuex";
//components
import ModalSearch from "./ModalSearch.vue";
import ModalPerfil from "./ModalPerfil.vue"
import MixedWidget15 from "@/components/widgets/mixed/Widget15.vue";
import GlobalService from "@/core/services/GlobalService"
import PayrollService from "@/core/services/PayrollService"
import FileService from "@/core/services/FileService"
import { errManager, showNotification } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
import { status_payroll } from "@/core/data/shared"

export default defineComponent({
    name: "planilla",
    components: { ModalSearch, ModalPerfil, MixedWidget15 },
    props: {
        previousRoute: {
            type: String,
            required: false,
        },
    },
    setup(props) {
        const store = useStore();
        const altura = screen.height;
        const gblAccount = inject<any>('gblAccount')
        const ModalSearchRef = ref<any>(null)
        const ta = ref(process.env.VUE_APP_TA)
        const checkAll = ref<boolean>(false)

        const { t } = useI18n();
        const loading = ref(false)
        const loading_club = ref(false)
        const selectClub = ref<any>(null)
        const selectStatus = ref<any>([0, 1, 2, 3, 4])
        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(100)
        //pagination end
        const action = ref<Number>(0)
        //const dialogSearch = ref(false)
        const dialogProfile = ref(false)
        const dataProfile = ref(<any>{})
        const listPayroll = ref(<any>[])
        const listClubs = ref<any[]>([])
        const listStatus = status_payroll
        const resGender = ref<any[]>([])
        const resChecks = ref<any[]>([])
        const listTypeFile = ref<any[]>([])
        const textSearch = ref('')
        const multipleSelection = ref<any[]>([])

        //provide shared data
        //provide("dialogSearch", dialogSearch)
        //provide("action", action)
        provide("dialogProfile", dialogProfile)
        provide("dataProfile", dataProfile)
        provide("listTypeFile", listTypeFile)

        const accountInfo: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        const openModalSearch = () => {
            if (ModalSearchRef.value) {
                ModalSearchRef.value.openModal();
            }
        }

        //metodo de respuesta del ModalSearch
        const onResponse = (data) => {
            nextTick(() => {
                if (!data.status) {
                    action.value = data.action
                    dataProfile.value = data
                    dialogProfile.value = true
                }
            })
        }

        const getListClubs = async () => {
            loading_club.value = true
            selectClub.value = null
            listClubs.value = []
            listPayroll.value = []
            resGender.value = []
            resChecks.value = []
            await GlobalService.post('payroll/clubs', {})
                .then((res) => {
                    listClubs.value = res.data
                    loading_club.value = false
                }).catch(({ response }) => {
                    loading_club.value = false
                    errManager(response)
                })
        }

        const geDataPayroll = async () => {
            loading.value = true
            await GlobalService.post('payroll', { textSearch: textSearch.value, idinstitution: selectClub.value, status: selectStatus.value })
                .then((res) => {
                    loading.value = false
                    listPayroll.value = res.data.list
                    resGender.value = res.data.gender
                    resChecks.value = res.data.checks
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                })
        }

        const onResponseMdPerfil = () => {
            geDataPayroll()
        }

        const onEdit = async (row, option) => {
            action.value = option
            dataProfile.value = row
            dialogProfile.value = true
        }

        const getListTypeFile = async () => {
            listTypeFile.value = []
            await FileService.getFiles('payroll', 'type')
                .then((res) => {
                    listTypeFile.value = res.data
                }).catch(({ response }) => {
                    listTypeFile.value = []
                })
        }

        const onDelete = (row) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: `${t('deleteRecord2')} <b>${row.firstname} ${row.lastname}</b> ${t('deleteRecord3')}`,
                icon: 'question',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return GlobalService.delete('payroll', row.idpayroll)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification({ title: result.value.title, message: result.value.message, status: result.value.status })
                    /*Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    */
                    result.value.status === 'success' && geDataPayroll();
                }
            })
        }

        const handleSelectionChange = (val: any[]) => {
            multipleSelection.value = []
            val.forEach(item => {
                if (item.hasOwnProperty('check') && (item.check == '0' || item.check == '4')) {
                    multipleSelection.value.push(item);
                }
            });
        }

        const sendDataValidation = () => {
            if (multipleSelection.value.length > 0) {
                Swal.fire({
                    title: 'Envío de información',
                    html: `¿Desea enviar <b>${multipleSelection.value.length} registros</b> para su revisión? Recuerde que una vez enviado no podrá realizar ninguna otra operación hasta que FEDUP haya resuelto la revisión`,
                    icon: 'question',
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    showCancelButton: true,
                    confirmButtonText: t('send'),
                    cancelButtonText: t('cancel'),
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return PayrollService.options('review', multipleSelection.value)
                            .then((res) => {
                                return res.data
                            }).catch(({ response }) => {
                                Swal.showValidationMessage(
                                    `Request failed: ${response.data.message}`
                                )
                            })
                    },
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        Swal.fire({
                            icon: result.value.status,
                            title: result.value.title,
                            html: result.value.message
                        })
                        result.value.status === 'success' && geDataPayroll();
                    }

                })
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    html: t('planilla1'),
                });
            }
        }

        const getListClubsAll = async () => {
            loading_club.value = true
            selectClub.value = null
            listClubs.value = []
            listPayroll.value = []
            resGender.value = []
            resChecks.value = []
            await GlobalService.get('api', 'institution?limit=0')
                .then((res) => {
                    listClubs.value = res.data?.data
                    loading_club.value = false
                }).catch(({ response }) => {
                    loading_club.value = false
                    errManager(response)
                })
        }

        const changeAll = () => {
            if(checkAll.value)
                getListClubsAll();
            else
                getListClubs();
        }

        onMounted(() => {
            //Tipos de documentos a subir
            getListTypeFile();
            geDataPayroll();
            getListClubs();
        })

        return {
            moment,
            altura,
            ModalSearchRef,
            gblAccount,
            ta,
            checkAll,
            t,
            loading,
            loading_club,
            selectClub,
            selectStatus,
            pageSize,
            currentPage,
            totalItems,
            action,
            dialogProfile,
            dataProfile,
            listPayroll,
            listClubs,
            listStatus,
            listTypeFile,
            resGender,
            resChecks,
            textSearch,
            accountInfo,
            //methods
            openModalSearch,
            onResponse,
            onResponseMdPerfil,
            getListTypeFile,
            geDataPayroll,
            onEdit,
            onDelete,
            sendDataValidation,
            handleSelectionChange,
            getListClubs,
            changeAll
        }

    },
})
